import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  payments: [],
  paymentsRef: null,
  paymentsLoaded: false
}

const getters = {
  payments (state) {
    return state.payments
  },
  paymentsRef (state) {
    return state.paymentsRef
  },
  paymentsLoaded (state) {
    return state.paymentsLoaded
  },
  paymentsByUser (state) {
    return (uid) => {
      let payments = []
      for (let p of state.payments) {
        if (p.uid === uid) payments.push(p)
      }
      return payments
    }
  },
  paymentByKey (state) {
    return (paymentId) => {
      return state.payments.find(p => {
        return p.key === paymentId
      })
    }
  }
}

const mutations = {
  setPayments (state, payload) {
    state.payments = payload
  },
  setPaymentsRef (state, payload) {
    state.paymentsRef = payload
  },
  setPaymentsLoaded (state, payload) {
    state.paymentsLoaded = payload
  }
}

const actions = {
  loadPayments: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('payments')
    ref.limitToLast(50).on('value', snapshot => {
      const payments = []
      snapshot.forEach(p => {
        payments.push({...p.val(), key: p.key})
      })
      store.commit('setPayments', payments)
      store.commit('setPaymentsRef', ref)
      store.commit('setPaymentsLoaded', true)
      resolve()
    })
  }),
  loadAllPayments: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('payments')
    ref.on('value', snapshot => {
      const payments = []
      snapshot.forEach(p => {
        payments.push({...p.val(), key: p.key})
      })
      store.commit('setPayments', payments)
      store.commit('setPaymentsRef', ref)
      store.commit('setPaymentsLoaded', true)
      resolve()
    })
  }),
  addPayment: (store, payload) => new Promise((resolve, reject) => {
    const newPayment = {...payload}
    store.getters.paymentsRef.push(newPayment).then(payment => {
      resolve(payment.key)
    }).catch(err => {
      reject(err)
    })
  }),
  updatePayment: (store, payload) => new Promise((resolve, reject) => {
    const newPayment = {...payload}
    store.getters.paymentsRef.child(newPayment.key).set(newPayment).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  resetPayments (store) {
    if (store.getters.paymentsRef) store.getters.paymentsRef.off()
    store.commit('setPayments', [])
    store.commit('setPaymentsRef', null)
    store.commit('setPaymentsLoaded', false)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/payments.js